/**
 * Lightweight placeholder while the second-nav chunk loads (dynamic import from HeaderNavigation_DGA).
 * Matches layout/height of the real bar to limit CLS.
 */
const HeaderDGASecondNavBarSkeleton = (): JSX.Element => (
  <div
    className="border-t border-b border-neutral-300 bg-neutral-100"
    aria-hidden="true"
  >
    <div className="responsive flex h-auto min-h-10 flex-wrap items-center justify-between gap-x-4 gap-y-2 py-2 md:h-10 md:py-0">
      <div className="h-6 max-w-[min(100%,28rem)] min-w-0 flex-1 animate-pulse rounded bg-neutral-200/80" />
      <div className="flex h-8 shrink-0 items-center gap-1.5">
        <span className="h-8 w-8 rounded bg-neutral-200/80" />
        <span className="h-8 w-8 rounded bg-neutral-200/80" />
        <span className="h-8 w-8 rounded bg-neutral-200/80" />
      </div>
    </div>
  </div>
);

export default HeaderDGASecondNavBarSkeleton;
